module.exports = __webpack_public_path__ + "img/shopify.f456c26e.png";